import NavLinks from './NavLinks';
import classes from './NavBar.module.css';

/** デスクトップ幅のグローバルナビ（720px 以下では非表示）。 */
const Navigation = () => {
  return (
    <nav className={classes.Navigation}>
      <NavLinks />
    </nav>
  );
};

export default Navigation;
